import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IsauthorizedService } from '../services/isauthorized.service';

@Injectable()
export class ViewUserActivityLogsGuard  {

 constructor(
     private readonly router: Router, private readonly isAuthorizedService: IsauthorizedService) {
   }
 
   canActivate(): Observable<boolean> | boolean {
     if (this.isAuthorizedService.checkControlAuthorization('subTabViewAuditLogs')) {
       return true;
     }
     this.router.navigate(['/'], { replaceUrl: true });
     return false;
   }
 
   canLoad(): Observable<boolean> | Promise<boolean> | boolean {
     return this.canActivate();
   }

}
